var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_68658",
    "data-name": "Group 68658",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17134",
    "data-name": "Rectangle 17134",
    width: 36,
    height: 36,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AI",
    transform: "translate(4.91 2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37324",
    "data-name": "Path 37324",
    d: "M14.41,7.455l.9,2.509a9.939,9.939,0,0,0,5.98,5.98l2.509.9a.257.257,0,0,1,0,.484l-2.509.9a9.939,9.939,0,0,0-5.98,5.98l-.9,2.509a.257.257,0,0,1-.484,0l-.9-2.509a9.939,9.939,0,0,0-5.98-5.98l-2.509-.9a.257.257,0,0,1,0-.484l2.509-.9a9.939,9.939,0,0,0,5.98-5.98l.9-2.509a.257.257,0,0,1,.484,0Z",
    transform: "translate(-4.364 -1.339)",
    fill: "#00e5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37325",
    "data-name": "Path 37325",
    d: "M23.9,2.087l.458,1.27a5.037,5.037,0,0,0,3.028,3.028l1.27.458a.13.13,0,0,1,0,.245l-1.27.458a5.037,5.037,0,0,0-3.028,3.028l-.458,1.27a.13.13,0,0,1-.245,0l-.458-1.27a5.037,5.037,0,0,0-3.028-3.028L18.9,7.088a.13.13,0,0,1,0-.245l1.27-.458a5.037,5.037,0,0,0,3.028-3.028l.458-1.27A.13.13,0,0,1,23.9,2.087Z",
    transform: "translate(-2.559 -2)",
    fill: "#1564e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37326",
    "data-name": "Path 37326",
    d: "M23.9,21.26l.458,1.27a5.037,5.037,0,0,0,3.028,3.028l1.27.458a.13.13,0,0,1,0,.245l-1.27.458a5.037,5.037,0,0,0-3.028,3.028l-.458,1.27a.13.13,0,0,1-.245,0l-.458-1.27a5.037,5.037,0,0,0-3.028-3.028l-1.27-.458a.13.13,0,0,1,0-.245l1.27-.458a5.037,5.037,0,0,0,3.028-3.028l.458-1.27A.13.13,0,0,1,23.9,21.26Z",
    transform: "translate(-2.559 0.396)",
    fill: "#d1131d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon2);
export default __webpack_public_path__ + "static/media/ai-icon-2.cb93a53502ab91b5bbed78e2fbb6a942.svg";
export { ForwardRef as ReactComponent };